// pages/Dashboard.jsx
import Capacity from "../components/ngoCapacityComponents/CapacityBuilding";
import HomeLayout from "../components/HomeLayout";

export default function CapacityBuildingPage() {
  return (
    <HomeLayout>
      <Capacity />
    </HomeLayout>
  );
}
